export const NLP_MODEL_TYPES = Object.freeze({
  GPT: 'gpt'
})
